/* eslint-disable */
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { useCustomerStore } from '@/stores/customer';
import { useKycStore } from '@/stores/kyc';
import { openModal } from '@kolirt/vue-modal';
import { useBestlineVideoStore } from '@/stores/bestline_video';
import CasinoLimits from '@/components/modals/CasinoLimits.vue';
import { useBonusStore } from '@/stores/bonus';
import { useDepositsStore } from '@/stores/bank/deposits';
import { usePaymentGatewaysStore } from '@/stores/payment_gateways';
import Swal from 'sweetalert2';
import { i18n } from '@/main';

const handleDepositFailed = (event) => {
	const customerStore = useCustomerStore();
	if (!customerStore.isLoggedIn) return;

	const bonusStore = useBonusStore();
	const depositsStore = useDepositsStore();
	const paymentGatewayStore = usePaymentGatewaysStore();
	const { t } = i18n.global;

	// 1. Immediately re-fetch offers to restore visibility
	bonusStore.fetchOffers();

	// 2. Safe slug lookup for active payment gateway
	const selectedPayment = paymentGatewayStore.payment_gateways?.find(
		(gw) => gw.id === paymentGatewayStore.selected_payment_gateway
	);
	if (selectedPayment?.slug) {
		depositsStore.fetchAvailableBonuses(selectedPayment.slug);
	}

	// 3. Notification presentation logic
	const hasOffer = Boolean(event.message?.has_offer);
	const isCancelled = event.message?.state === 'cancelled';

	let title, text;
	if (isCancelled) {
		title = t('bank.deposit.deposit_cancelled_title') !== 'bank.deposit.deposit_cancelled_title'
			? t('bank.deposit.deposit_cancelled_title') : 'Deposit Cancelled';
		text = hasOffer
			? (t('bank.deposit.deposit_cancelled_offer_restored') !== 'bank.deposit.deposit_cancelled_offer_restored'
				? t('bank.deposit.deposit_cancelled_offer_restored') : 'Deposit was cancelled. Your deposit offer is available again.')
			: (t('bank.deposit.deposit_cancelled_msg') !== 'bank.deposit.deposit_cancelled_msg'
				? t('bank.deposit.deposit_cancelled_msg') : 'Your deposit request was cancelled.');
	} else {
		title = t('bank.deposit.deposit_failed_title') !== 'bank.deposit.deposit_failed_title'
			? t('bank.deposit.deposit_failed_title') : 'Deposit Failed';
		text = hasOffer
			? (t('bank.deposit.deposit_failed_offer_restored') !== 'bank.deposit.deposit_failed_offer_restored'
				? t('bank.deposit.deposit_failed_offer_restored') : 'Deposit was not completed. Your deposit offer is available again.')
			: (t('bank.deposit.deposit_failed_msg') !== 'bank.deposit.deposit_failed_msg'
				? t('bank.deposit.deposit_failed_msg') : 'Your deposit was not completed.');
	}

	Swal.fire({
		title,
		text,
		icon: isCancelled ? 'info' : 'warning',
		confirmButtonText: (t('general.ok') && t('general.ok') !== 'general.ok') ? t('general.ok') : 'OK',
	});
};

const sbSocketData = () => {
	if (!process.env.VUE_APP_PUSHER_KEY) {
		// cannot connect to pusher without key, so just return
		return;
	}
	
	const customerStore = useCustomerStore();

	if (!process.env.VUE_APP_PUSHER_KEY || !process.env.VUE_APP_PUSHER_HOST) {
		return;
	}

	window.Pusher = Pusher;

	window.Echo = new Echo({
		broadcaster: process.env.VUE_APP_PUSHER_BROADCASTER || 'pusher',
		key: process.env.VUE_APP_PUSHER_KEY,
		cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
		wsHost: process.env.VUE_APP_PUSHER_HOST || window.location.hostname,
		wsPort: process.env.VUE_APP_PUSHER_PORT,
		forceTLS: process.env.VUE_APP_PUSHER_FORCE_TLS === 'true',
		disableStats: true,
		authEndpoint: process.env.VUE_APP_API_URL + '/subscribe',
		auth: {
			headers: {
				Authorization: `Bearer ${customerStore.auth_token}`, // BIRA TOKEN
			}
		}
	});

	window.Echo.channel('messages')
		.listen('.sb', (event) => {
			console.log(event);
		})
		.listen('.video-streaming', (event) => {
			useBestlineVideoStore().setVideoEvents(event.message);
		});

	if (customerStore.isLoggedIn) {
		window.Echo.private(`messages.${customerStore.customer.id}`)
			.listen('.private_message', (event) => {
				console.log(event);
			})
			.listen('.update_balance', (event) => {
				customerStore.setCustomerBalance(event.message);
			})
			.listen('.casino_limit_notification', (event) => {
				openModal(CasinoLimits, { data: event.message }).catch(() => {});
			})
			.listen('.live_casino_limit_notification', (event) => {
				openModal(CasinoLimits, { data: event.message }).catch(() => {});
			})
			.listen('.kyc_completed', (event) => {
				useKycStore().receiveCompletionEvent(event.message);
			})
			.listen('.deposit_failed', handleDepositFailed);
		// .listen('.referral_activity', (event) => {
		// 	console.log(event);
		// })
	}
};

export default sbSocketData;
